import { render, staticRenderFns } from "./paymentComponent.vue?vue&type=template&id=13922eb8"
import script from "./paymentComponent.vue?vue&type=script&lang=js"
export * from "./paymentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiCheckoutInfoSummary: require('/home/node/app/components/ui/checkout/infoSummary.vue').default,UiButtonComponent: require('/home/node/app/components/ui/buttonComponent.vue').default,ControllerPayment: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/checkout/ControllerPayment.js').default})
